import { getThemeBasedOnDomain } from '../lib/helpers';
import { useApplicationBranding } from '../lib/useApplicationBranding';

interface HeaderProps {
  heading: string;
  paragraph?: string;
  hideAuthMode?: boolean;
}

export default function Header(props: HeaderProps) {
  const theme = getThemeBasedOnDomain();
  const branding = useApplicationBranding();

  // When the organisation has its own logo, show it across the top
  // (banner-shaped: fixed height, natural width). Otherwise fall back to the
  // default domain logo (square).
  const orgLogoUrl = branding?.logoUrl;
  const orgName = branding?.title || undefined; // || branding?.name;

  return (
    <div className="">
      {orgLogoUrl ? (
        <img
          alt={`${orgName || theme.name} Logo`}
          className="h-16 w-auto max-w-full object-contain mx-auto"
          src={orgLogoUrl}
        />
      ) : (
        <img
          alt={`${theme.name} Logo`}
          className="h-16 w-16 rounded-md mx-auto"
          src={theme.logo}
        />
      )}
      {orgName && (
        <p className="mt-3 text-center text-sm font-medium text-gray-700">
          {orgName}
        </p>
      )}
      <h1 className="mt-6 text-3xl font-extrabold text-gray-900 mb-3">
        {props.heading}
      </h1>
      <p className="text-zinc-500 mb-3">{props.paragraph}</p>
    </div>
  );
}
